module.exports = __webpack_public_path__ + "static/media/timile_ta_bujye_xau.1be0adeb.ogg";